module.exports = __webpack_public_path__ + "img/河南农商银行.0eeb2a33.png";